import React, { useEffect, useState } from 'react'
import styles from './style.module.css'
import { getQuery, setEvent } from '@/core/utile'
import { isWechat } from '@weike/toolkit'
import { Toast } from 'antd-mobile'
import 'antd-mobile/lib/toast/style/css'
import eduHeroImg from '../guide-app/images/full-edu.png'

declare const wx: any

const { form = '', app_type = 'lihua', scene = 'webview' } = getQuery()
const isInWechat = isWechat()

type AppConfig = {
  appId: string
  logoUrl: string
  downloadUrl: string
  scheme: string
  appName: string
  heroImage: string
  heroImagePosition: string
  title: string
  highlight: string
  subtitle: string
  featureTags: string[]
  layoutMode: 'poster' | 'default'
}

// 各 app 类型对应的本地配置
const APP_CONFIG: Record<string, AppConfig> = {
  lihuaedu: {
    appId: 'wxe5facdcdf8c481d3',
    logoUrl: 'https://img.lycheer.net/xupload/519/6911c3fafa2c11dc83d2974c.png',
    downloadUrl:
      'https://a.app.qq.com/o/simple.jsp?pkgname=com.lizhiweike.lihuaedu',
    scheme: 'lihuaedu',
    appName: '梨花教育',
    heroImage: eduHeroImg,
    heroImagePosition: 'center 74%',
    title: '让你的成长',
    highlight: '更有方向',
    subtitle: '专注家庭教育与名师课程，学习陪伴更省心',
    featureTags: ['名师课程', '家庭教育', '每日精进'],
    layoutMode: 'default',
  },
  lihua: {
    appId: 'wxb14e61b3b90605ad',
    logoUrl: 'https://img.lycheer.net/xupload/446/69dde9752ae24854a7ff1609.png',
    downloadUrl:
      'https://a.app.qq.com/o/simple.jsp?pkgname=com.lizhiweike.lihua',
    scheme: 'lihua',
    appName: '梨花声音研修院',
    heroImage:
      'https://img.lycheer.net/xupload/446/69e5f6b22ae248e346ff31ef.png',
    heroImagePosition: 'center 76%',
    title: '让你的声音',
    highlight: '更有价值',
    subtitle: '专注声音美化，实现声音梦想',
    featureTags: [],
    layoutMode: 'poster',
  },
}

const currentAppConfig = APP_CONFIG[app_type] || APP_CONFIG['lihua']

const launchStyleConfig: React.CSSProperties = {
  fontSize: '28px',
  fontWeight: 800,
  color: '#ffffff',
  lineHeight: '1',
  width: '100%',
  height: '60px',
  background: 'linear-gradient(180deg, #ff8b35 0%, #ff6618 100%)',
  borderRadius: '999px',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  overflow: 'hidden',
  boxShadow: '0 10px 24px rgba(255, 118, 38, 0.18)',
}

const posterLaunchStyleConfig: React.CSSProperties = {
  fontSize: '24px',
  fontWeight: 800,
  color: '#ffffff',
  lineHeight: '1',
  width: '100%',
  height: '56px',
  background: 'linear-gradient(180deg, #ff8b35 0%, #ff6618 100%)',
  borderRadius: '999px',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  overflow: 'hidden',
  boxShadow: '0 12px 28px rgba(255, 118, 38, 0.2)',
}

const styleToCssString = (styleObj: React.CSSProperties) => {
  return Object.entries(styleObj)
    .map(([key, value]) => {
      const cssKey = key.replace(/[A-Z]/g, m => '-' + m.toLowerCase())
      return `${cssKey}: ${value};`
    })
    .join('')
}

const generateInlineStyle = (
  styleObj: React.CSSProperties,
  className = 'launch-btn',
) => {
  const cssString = styleToCssString(styleObj)
  return `
    <style>
      .${className} {
        ${cssString}
      }

      .${className} span {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 1;
        line-height: 1.2;
        text-align: center;
      }

      .${className}:active {
        background: linear-gradient(180deg, #ff7d26 0%, #f45a11 100%);
        transform: translateY(1px);
      }
    </style>
  `
}

const inlineStyle = generateInlineStyle(launchStyleConfig)
const posterInlineStyle = generateInlineStyle(posterLaunchStyleConfig)

const LaunchApp = () => {
  const {
    appId,
    appName,
    logoUrl,
    downloadUrl,
    scheme,
    heroImage,
    heroImagePosition,
    title,
    highlight,
    subtitle,
    featureTags,
    layoutMode,
  } = currentAppConfig
  const [isWxReady, setIsWxReady] = useState(false)
  const [isHarmonyGuideVisible, setIsHarmonyGuideVisible] = useState(false)
  const userAgent =
    typeof navigator !== 'undefined' ? navigator.userAgent || '' : ''
  const isOpenHarmony = /OpenHarmony/i.test(userAgent)
  const shouldShowHarmonyGuide = isInWechat && isOpenHarmony
  const isPosterLayout = layoutMode === 'poster'
  const launchUrl =
    typeof window === 'undefined'
      ? `${scheme}://${scene}`
      : `${scheme}://${scene}${window.location.search}`

  useEffect(() => {
    if (typeof wx !== 'undefined' && wx) {
      wx.ready(() => {
        setIsWxReady(true)
      })
      return
    }

    setIsWxReady(true)
  }, [])

  useEffect(() => {
    if (!shouldShowHarmonyGuide) {
      return
    }
    setEvent('ra_launch_edu_app', {
      status: 'openharmony_guide',
      app_type,
    })
  }, [shouldShowHarmonyGuide])

  useEffect(() => {
    if (!isWxReady || shouldShowHarmonyGuide) {
      return
    }

    const launchBtn = document.getElementById('wx-launch-app-btn')
    if (!launchBtn) {
      return
    }

    const handleLaunch = () => {
      setEvent('ra_launch_edu_app', { status: 'success' })
    }
    const handleError = () => {
      Toast.info('未安装 App，正在跳转下载页')
      setEvent('ra_launch_edu_app', { status: 'fail' })
      setTimeout(() => {
        window.location.replace(downloadUrl)
      }, 2000)
    }

    launchBtn.addEventListener('launch', handleLaunch)
    launchBtn.addEventListener('error', handleError)

    return () => {
      launchBtn.removeEventListener('launch', handleLaunch)
      launchBtn.removeEventListener('error', handleError)
    }
  }, [downloadUrl, isWxReady, shouldShowHarmonyGuide])

  const showHarmonyGuideModal = () => {
    setIsHarmonyGuideVisible(true)
    setEvent('ra_launch_edu_app', {
      status: 'openharmony_tip_click',
      app_type,
    })
  }

  const closeHarmonyGuideModal = () => {
    setIsHarmonyGuideVisible(false)
  }

  const launchApp = () => {
    const timeout = 2000
    const startTime = Date.now()
    Toast.info('正在尝试打开 App...')
    window.location.href = launchUrl

    const timer = window.setTimeout(() => {
      if (Date.now() - startTime < timeout + 500) {
        Toast.info('未找到 App，正在跳转下载页')
        window.setTimeout(() => {
          window.location.replace(downloadUrl)
        }, 1500)
      }
    }, timeout)

    const handleVisibilityChange = () => {
      if (document.hidden) {
        clearTimeout(timer)
      }
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
  }

  const renderLaunchButton = () => {
    if (shouldShowHarmonyGuide) {
      return (
        <button
          type="button"
          className={styles.launchButton}
          onClick={showHarmonyGuideModal}
        >
          <span>打开APP</span>
        </button>
      )
    }

    if (isInWechat) {
      const currentInlineStyle = isPosterLayout
        ? posterInlineStyle
        : inlineStyle
      return (
        <div
          className={styles.wxLaunchWrapper}
          dangerouslySetInnerHTML={{
            __html: `
              <wx-open-launch-app
                id="wx-launch-app-btn"
                style="display:block;width:100%;"
                appid="${appId}"
                extinfo='{"type":"router", "url": "${launchUrl}", "form": "${form}"}'
              >
                <script type="text/wxtag-template">
                  ${currentInlineStyle}
                  <div class="launch-btn"><span>打开APP</span></div>
                </script>
              </wx-open-launch-app>
            `,
          }}
        />
      )
    }

    return (
      <button type="button" className={styles.launchButton} onClick={launchApp}>
        <span>打开APP</span>
      </button>
    )
  }

  return (
    <div
      className={`${styles.launch_app} ${
        isPosterLayout ? styles.posterPage : styles.defaultPage
      }`}
    >
      <div
        className={`${styles.content} ${
          isPosterLayout ? styles.posterContent : styles.defaultContent
        }`}
      >
        {isPosterLayout && (
          <img className={styles.posterImage} src={heroImage} alt={appName} />
        )}

        {!isPosterLayout && (
          <div className={styles.brandBar}>
            <img className={styles.brandLogo} src={logoUrl} alt={appName} />
            <span className={styles.brandName}>{appName}</span>
          </div>
        )}

        {!isPosterLayout && (
          <>
            <div className={styles.heroWrap}>
              <div className={styles.heroGlow} />
              <img
                className={styles.heroImage}
                src={heroImage}
                style={{ objectPosition: heroImagePosition }}
                alt={appName}
              />
            </div>

            <h1 className={styles.title}>
              {title}
              <span className={styles.titleHighlight}>{highlight}</span>
            </h1>
            <p className={styles.subtitle}>{subtitle}</p>
          </>
        )}

        {featureTags.length > 0 && (
          <div className={styles.featureRow}>
            {featureTags.map(tag => (
              <span key={tag} className={styles.featureTag}>
                {tag}
              </span>
            ))}
          </div>
        )}

        <div
          className={`${styles.actionArea} ${
            isPosterLayout ? styles.posterActionArea : ''
          }`}
        >
          {renderLaunchButton()}
        </div>

        <p
          className={`${styles.pageHint} ${
            isPosterLayout ? styles.posterPageHint : ''
          }`}
        >
          {shouldShowHarmonyGuide
            ? '鸿蒙微信环境下，点击打开APP后会提示你前往默认浏览器'
            : isInWechat
            ? '微信内可直接唤起 App，未安装时会自动跳转下载页'
            : '若未安装 App，将自动为你跳转到下载页'}
        </p>
      </div>

      {shouldShowHarmonyGuide && isHarmonyGuideVisible && (
        <div className={styles.modalMask} onClick={closeHarmonyGuideModal}>
          <div
            className={styles.harmonyModal}
            onClick={event => event.stopPropagation()}
          >
            <button
              type="button"
              className={styles.modalClose}
              onClick={closeHarmonyGuideModal}
              aria-label="关闭提示"
            >
              ×
            </button>
            <div className={styles.modalTag}>鸿蒙设备提示</div>
            <div className={styles.modalTitle}>请在微信外打开页面</div>
            <div className={styles.modalDesc}>
              鸿蒙微信内暂不支持直接唤起 App，请按下面步骤操作
            </div>
            <div className={styles.modalSteps}>
              <div className={styles.modalStep}>
                <span className={styles.stepIndex}>1</span>
                点击右上角“...”
              </div>
              <div className={styles.modalStep}>
                <span className={styles.stepIndex}>2</span>
                选择“在默认浏览器打开”
              </div>
              <div className={styles.modalStep}>
                <span className={styles.stepIndex}>3</span>
                在浏览器中打开页面，点击 “打开 App”
              </div>
            </div>
            <button
              type="button"
              className={styles.modalConfirm}
              onClick={closeHarmonyGuideModal}
            >
              我知道了
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default LaunchApp
